import type { TeamAcronym } from '@glovo/organisation'
import { createContext } from 'react'
import type { ErrorBoundaryCustomContext, Tier } from './types'

export type ErrorBoundaryContextType = {
  id: string
  owner: TeamAcronym
  customContext?: ErrorBoundaryCustomContext
  tier?: Tier
}

export const ErrorBoundaryContext = createContext<ErrorBoundaryContextType | null>(null)
